import moment from "moment"

  export function sendSuccessNotice (notice) {
    window.getApp.$emit('APP_RESOURCE_UPDATED', notice);
  }
  
  export function sendErrorNotice (notice) {
    window.getApp.$emit('APP_RESOURCE_FAILED', notice);
  }

  export function refreshResource () {
    window.getApp.$emit('REQUEST_REFRESH_DATA');
  }

  export function buildBreadcrumb(routeName, routePath, pId, title, menu, paths) {
    let breadcrumbs = [];
    menu.forEach(item => {
      if (item.name === routeName) {
        breadcrumbs.push({
          text: item.title,
          link: false,
          href: ""
        });
      } else if (item.items) {
        breadcrumbs = _.concat(breadcrumbs, buildBreadcrumb(routeName, routePath, pId, title, item.items, paths))
      } else if (item.children) {
        let child = item.children.find(i => {
          return i.component === routeName;
        });
        if (child) {
          let path = _.find(paths, { name: item.name });
          breadcrumbs.push({
            text: item.title,
            disabled: false,
            href: path ? path.path : ""
          });
          breadcrumbs.push({
            text: title || `${child.title} (#${pId})`,
            link: false,
            href: ""
          });
        }
      }
    });
    return breadcrumbs;
  }

  export function getCurrentTime() {
    var d = new Date();
    d.setTime( d.getTime());
    return moment(d);
  }

  export function proxyImage(imageUrl) {
    if (!imageUrl) {
        return ''
    };
    
    // Nếu ảnh đã là từ domain local thì không cần proxy
    if (process.env.NODE_ENV === "development" || imageUrl.startsWith('/') || imageUrl.includes(window.location.hostname) || imageUrl.includes('firebase') || !imageUrl.includes('alicdn.com')) {
        return imageUrl;
    }
    
    return `https://dash.phanmemdathangoee.com/oee-images/${imageUrl.replace(/https?:\/\//, '')}`;
  }